module.exports = __webpack_public_path__ + "static/stratford-f1329ba2454d1d2995bfd16eafc2462d.jpg";